<template>
  <div>
    <LoadingSpinner v-if="processing" class="text-gray-400" />
    <div v-else>
      <select
        class="bg-transparent"
        :value="ignoreFraudScore"
        @change="updateIgnoreFraudScore($event.target.value)"
      >
        <option value="0">No</option>
        <option value="1">Yes</option>
      </select>
      <span
        v-if="error"
        class="text-red-500"
      >
        Failed!
      </span>
    </div>
  </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";

const Order = ApiFactory.get("orders");

export default {
  name: "IgnoreFraudScore",
  data() {
    return {
      ignoreFraudScore: 1,
      processing: false,
      error: false,
    };
  },
  created() {
    this.ignoreFraudScore = this.params.value;
  },
  methods: {
    updateIgnoreFraudScore(value) {
      this.processing = true;
      this.error = false;

      Order.updateIgnoreFraudScore(this.params.data?.SourceOrderNumber, value)
        .then(response => this.ignoreFraudScore = response.data.body?.LocalSortInteger2)
        .catch(() => this.error = true)
        .finally(() => this.processing = false);
    }
  }
};
</script>
